import React from 'react';
import SidebarModal from '../../../../components/sidebarModal/SidebarModal';

export const CreateUnit = ({ createUnitProps, createUnitFormRef, handleOnSubmit, createUnitForm, createUnitFormError, handleOnBlur, handleOnChange, setToggleCreateUnit, createUnitBtnLoader }) => {
  return (
    <SidebarModal {...createUnitProps} className="sidebar__modal--right" title="Create Unit">
      <form name="create-unit" ref={createUnitFormRef} className="ant-form ant-form-horizontal" onSubmit={(event) => handleOnSubmit({ event: event, form: createUnitProps })}>
        <div className="form-group relative">
          <label className="label mb-1 d-block" htmlFor="createUnitName">
            <b className="required">Name:</b>
          </label>

          <input type="text" placeholder="Name" name="createUnitName" id="createUnitName" data-cy="create-unit-name-input" value={createUnitForm.name || ''} onChange={(event) => handleOnChange(event)} onBlur={(event) => handleOnBlur(event)} className={`input ${createUnitFormError.name ? 'input-error' : ''}`} />

          <p data-cy="modal-create-unit-name-error" className={`error__onblur ${createUnitFormError.name ? 'error' : ''}`}>
            * This field is required!
          </p>
        </div>

        <div className="form-group form-group-sidebar">
          <button data-cy="modal-create-unit-cancel-btn" type="button" className="btn btn-primary-link" onClick={() => setToggleCreateUnit(false)}>
            <span className="text">Cancel</span>
          </button>

          {!createUnitBtnLoader ? (
            <button data-cy="modal-create-unit-submit-btn" type="submit" className="btn btn-primary">
              <span className="text">Create Unit</span>
            </button>
          ) : (
            <button type="button" className="btn btn-primary-outline">
              <span className="text">Creating Unit...</span>
            </button>
          )}
        </div>
      </form>
    </SidebarModal>
  );
};
